import styles from './Checkbox.module.css';

export default function Checkbox({ ifSelected, handleClick }) {
  return (
    <div
      onClick={() => handleClick(!ifSelected)}
      className={
        ifSelected ? styles.checkbox + ' ' + styles.checkbox_active : styles.checkbox
      }></div>
  );
}
